import React, { useMemo } from 'react';
import * as THREE from 'three'
import Word from '../Word';

interface ICloudProps {
  children?: React.ReactNode;
  rad?: number;
  count?: number;
}

const skills = [
  'React', // 1
  'RTK', // 2
  'TypeScript', // 3
  'JavaScript', // 4
  'Next.js', // 5
  'styled-components', // 6
  'Apollo', // 7
  'SWR', // 8
  'Docker', // 9
  'Git', // 10
  'React-JSS', // 11
  'HTML5', // 12
  'RTL', // 13
  'SCSS', // 14
  'Pixel Perfect', // 15
  'Jest', // 16,
  'Figma', // 17
  'D3.js', // 18
  'Yandex Maps', // 19
  'Node', // 20
  'GraphQL', // 21
  'REST API', // 22
  'VS Code', // 23
  'Redux', // 24
  'SSG', // 25
  'React Hook Form', // 26
  'MongoDB', // 27
  'PostgreSQL', // 28
  'Redis', // 29
  'Zustand', // 30
  'Express', // 31
  'Webpack', // 32
  'BEM', // 33
  'GeoJSON', // 34
  'Storybook', // 35
  'React-query', // 36
];

const Cloud:React.FC<ICloudProps> = ({ rad = 20, count = 4 }) => {
  // Create a count x count random words with spherical distribution
  const words = useMemo(() => {
    let wordCounter = 0;
    const temp = []
    const spherical = new THREE.Spherical()
    const phiSpan = Math.PI / (count + 1)
    const thetaSpan = (Math.PI * 2) / count
    for (let i = 1; i < count + 1; i++)
      for (let j = 0; j < count; j++) {
        temp.push([
          new THREE.Vector3().setFromSpherical(spherical.set(rad, phiSpan * i, thetaSpan * j)),
          skills[wordCounter]
        ]);
        wordCounter++;
      }
    return temp
  }, [count, rad])

  return (
    <>
     { words.map(([pos, word], index) => (
      <Word key={index} position={pos as THREE.Vector3}>
        {word as React.ReactNode}
      </Word>
     )) }
    </>
  )
}

export default Cloud;
